import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Telescope, LogOut } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const Header: React.FC = () => {
  const { isAuthenticated, displayName, signOut, signIn } = useAuth();
  const nav = useNavigate();
  const isLanding = useLocation().pathname === '/';

  return (
    <header className="relative z-20 flex items-center justify-between px-6 py-5 md:px-10">
      <Link to={isAuthenticated ? '/dashboard' : '/'} className="flex items-center gap-2 group">
        <div className="relative">
          <Telescope className="h-6 w-6 text-nebula-300 group-hover:text-nebula-200 transition-colors" />
          <div className="absolute inset-0 blur-xl bg-nebula-500/40 -z-10" />
        </div>
        <span className="font-display text-lg font-semibold tracking-tight">
          Pancake<span className="text-nebula-300">Stack</span>
        </span>
      </Link>

      {/* whitespace-nowrap on every nav button so labels can't wrap mid-word
          on tight widths. Sign out drops to icon-only below md so the row
          fits at 375px even with the new Dashboard link added. */}
      <nav className="flex items-center gap-1 md:gap-4">
        {isLanding && (
          <a
            href="/sky/"
            className="whitespace-nowrap text-sm text-white/70 hover:text-white transition-colors px-3 py-1.5"
          >
            Sky map
          </a>
        )}
        {isAuthenticated ? (
          <>
            <button
              onClick={() => nav('/dashboard')}
              className="whitespace-nowrap text-sm text-white/70 hover:text-white transition-colors px-2 md:px-3 py-1.5"
            >
              Dashboard
            </button>
            <button
              onClick={() => nav('/collections')}
              className="whitespace-nowrap text-sm text-white/70 hover:text-white transition-colors px-2 md:px-3 py-1.5"
            >
              Collections
            </button>
            <button
              onClick={() => nav('/jobs')}
              className="whitespace-nowrap text-sm text-white/70 hover:text-white transition-colors px-2 md:px-3 py-1.5"
            >
              Stacks
            </button>
            <button
              onClick={() => nav('/profile')}
              className="hidden md:block whitespace-nowrap text-sm text-white/50 hover:text-white transition-colors"
            >
              {displayName()}
            </button>
            <button
              onClick={signOut}
              aria-label="Sign out"
              title="Sign out"
              className="flex items-center gap-1.5 whitespace-nowrap text-sm text-white/70 hover:text-white transition-colors px-2 md:px-3 py-1.5"
            >
              <LogOut className="h-4 w-4" />
              <span className="hidden md:inline">Sign out</span>
            </button>
          </>
        ) : (
          <button
            onClick={signIn}
            className="whitespace-nowrap px-4 py-2 rounded-full bg-white/10 hover:bg-white/20 backdrop-blur text-sm font-medium transition-colors border border-white/10"
          >
            Sign in
          </button>
        )}
      </nav>
    </header>
  );
};

export default Header;
